/**
 * The View for modal used to populate EVM mappings prior to starting doc
 * 
 * This is quite a hefty class as it's basically a several page app squeezed into a single modal. Short of putting it in an iframe 
 * and having it live on its own page this was the best option
 * @class
 * @augments UserDocs.View.Modal.Base
 */
UserDocs.View.Modal.EVMModal = UserDocs.View.Modal.Base.extend(
/** @lends UserDocs.View.Modal.EVMModal# */
{
	/** to be given to the generated element */
	id: "document-evm-modal",
			
	/** define the other views */
	$viewLoading: 		null,
	$viewInit:			null,
	$viewTemplates:		null,
	$viewDataPicker: 	null,
	$viewDocs: 			null,
	$viewReg: 			null,
	$viewSummary:		null,
	
	/** template to use for the element */
	template: _.template($('#model_template_evm_loading').html()),
	
	/** template list used */
	templateList: {
		"init": 			$('#model_template_evm_init').html(),
		"init_passdata": 	$('#model_template_evm_init_passdata').html(),
		"templates": 		$('#model_template_evm_choose_template').html(),
		"loading": 			$('#model_template_evm_loading').html(),
		"documents": 		$('#model_template_evm_document_select').html(),
		"register": 		$('#model_template_evm_registration').html(),
		"transfer":			$('#model_template_evm_transfer').html(),
		"summary":			$('#model_template_evm_summary').html()
	},

	/** template for help dialog */
	helpTemplate: _.template($('#modal_template_evm_help').html()),
	
	/** template for help dialog */
	helpTemplateList: {
		"init": 			$('#modal_template_evm_help').html(),
		"init_passdata": 	$('#modal_template_evm_help_transfer_data').html(),
		"templates": 		$('#modal_template_evm_help_templates').html(),
		"documents":  		$('#modal_template_evm_help_documents').html(),
		"register": 		$('#modal_template_evm_help_reg').html(),
		"transfer": 		$('#modal_template_evm_help_data').html(),
		"register_summary": $('#modal_template_evm_help_reg_success').html(),
		"transfer_summary": $('#modal_template_evm_help_data_success').html()
	},
	
	/** title of the modal - replaced with a custom header in translations */
	title: "",

	/** id of selected source doc */
	currentDoc: null,
	
	/** a list of the source documents */
	sourceDocList: null,
	
	/** reference to our evm document */
	evmdocument: null,

    /** boolean to determine whether the customer can go back */
    allowBack: true,

    /** boolean to determine whether multiple documents can be transfered */
    allowMultiple: true,

	/** events we are listening to */
	events: {
		"change .e_evm_transfer_toggle_all":				"toggleAllDataFields",
		"click .e_evm_transfer_form td":					"toggleDataField",
		"click .e_evm_transfer_form .e_evm_transfer_data_table input":	"setDataField",

		"click #e_evm_init_option_start": 					"openTemplate",
		"click #e_evm_summary_start": 						"openTemplate",
		"click .e_evm_finish_document":						"openTemplate",

		"click #e_evm_init_option_document_action":			"showDocumentList",
		"click #e_evm_summary_document_action":				"showDocumentList",
		"click .e_btn_evm_select_doc":						"showDocumentData",
		"click #e_evm_confirm_doc_data":					"submitEVMDocumentTable",

		"click #e_evm_init_option_registration_action": 	"showRegistrationData",
		"click .e_evm_registration_confirm":				"submitRegistrationEVMs",

		"keyup .e_evm_document_select_search_template": 	"search",
		"change .e_evm_document_select_search_template": 	"search",
		"mouseup .e_evm_document_select_search_template": 	"search",
		
		"click .e_evm_orderby a":							"sort",
		
		"click .e_btn_back":								"back"
	},
				
	clear: function() {
		if (this.$viewLoading) 		this.$viewLoading.hide();
		if (this.$viewInit) 		this.$viewInit.hide();
		if (this.$viewTemplates) 	this.$viewTemplates.hide();
		if (this.$viewDataPicker) 	this.$viewDataPicker.hide();
		if (this.$viewDocs) 		this.$viewDocs.hide();
		if (this.$viewReg) 			this.$viewReg.hide();
		if (this.$viewSummary) 		this.$viewSummary.hide();
	},
	
	back: function(){
		this.clear();
		this.currentDoc = null;
		this.modal.dialog("option", "title", i18n('js_evm_please_select_document'));
		this.$viewDocs.show();
		this.resize();
	},
	
	loading: function() {
		this.clear();
		this.$viewLoading.show();
		this.resize();
	},
	
	/** used when not in conjunction with MyServices or MyDocuments */
	loadTemplate: function(url) {
        let _this = this;
        _this.removeCloseButton(); // Close button removed in all instances
		this.destinationUrl = url; // keep a record of the original destination
		this.model = new UserDocs.Model.EVMDocument();
		this.render();
		if (url.indexOf("additem") > 1) {
			//sites where products have price of 0.
			let productPriceId = ele.uri.getParameterByName(url, 'productpriceid');
			
			this.model.addItem(productPriceId).then(function(){
				//this is always a new document. Start the EVM process
				if (_this.model.get("GUID")) {
					_this.evmdocument = _this.model;
					_this.$viewLoading = _this.$el.children();
					_this.loadInit(false);
				} else {
					window.top.location.href = ele.uri.buildUrl("addItem", {productpriceid:productPriceId});
				}
			}).catch(function() {
			    //either the item is not an EVM document or the process has errored. Continue to document
                window.top.location.href = ele.uri.buildUrl("addItem", {productpriceid:productPriceId});
            });
			
		}
		else if (url.indexOf("createdocument") > 1) {
            //sites where products have price of 0.
            let rapidocsid = ele.uri.getParameterByName(url, 'rapidocsid');
            let serviceid = ele.uri.getParameterByName(url, 'serviceid');

            this.model.createDocument(rapidocsid, serviceid).then(function(){
                //this is always a new document. Start the EVM process
                if (_this.model.get("GUID")) {
                    _this.evmdocument = _this.model;
                    _this.$viewLoading = _this.$el.children();
                    _this.loadInit(false);
                } else {
                    console.log('fail');
                    //window.top.location.href = ele.uri.buildUrl("createdocument", {rapidocsid:rapidocsid,serviceid:serviceid});
                }
            });
        }
		else {
			//this is a trial document
            let templateId = ele.uri.getParameterByName(url, 'rapidocsid');
			this.model.loadTrialDocument(templateId)
                .then(function() {
				if (_this.model.guid != 0) {
					//document trial already exists - redirect
					let vars = {rapidocsid:templateId};
					if (ele.uri.getParameterByName(url, 'productpriceid')) {
						_this.close();
						vars.productpriceid = ele.uri.getParameterByName(url, 'productpriceid');
					}
					_this.close();
					window.top.location.href = ele.uri.buildUrl("tryDocument", vars);
				} else {
					_this.evmdocument = _this.model;
					_this.$viewLoading = _this.$el.children();
					_this.loadInit(false);
				}
			}).catch(function () {//no docs found or error thrown - open template
				if (_this.model.guid != 0) {
					//document trial already exists - redirect
                    let vars = {rapidocsid:templateId};
					if (ele.uri.getParameterByName(url, 'productpriceid')) {
						vars.productpriceid = ele.uri.getParameterByName(url, 'productpriceid');
					}
					window.top.location.href = ele.uri.buildUrl("tryDocument", vars);
				} else {
					if (ele.config.permissions.evmregistration) {
						//hide doc option but show registration
						_this.evmdocument = _this.model;
						_this.$viewLoading = _this.$el.children();
						_this.loadInit(true);
					} else {
						_this.evmdocument = _this.model;
						_this.openTemplate();
					}
				}
			});
		}
	},

    //@parameter nodocuments: whether to force hide the document option
	loadInit: function(nodocuments) {
	    if(nodocuments == false){
	        nodocuments = !ele.config.usersession.lastDocument; // If there are no documents then we should not offer existing documents.
        }
        let _this = this;
		if (ele.config.permissions.evmregistration) {
			this.evmdocument.getRegistrationEVMs().then(function(regData) {
                let registrationEVMs = _this.parseRegEvms(_this.evmdocument.EVMData, regData);
			    if (Object.keys(registrationEVMs).length === 0 && (!ele.config.permissions.evmdocuments || nodocuments)) {
			        //there's no reg EVMs abort AND we're not showing document option
                    _this.openTemplate();
                    return;
                }
				_this.$viewLoading.hide();
				_this.$viewInit = $(
						_.template(_this.templateList.init)( 
						{
							evms: registrationEVMs,
							nodocuments: nodocuments
						}
					)
				);
				_this.$viewInit.appendTo(_this.$el);
				_this.resize();
			});
		} else {
			this.$viewLoading.hide();
			this.$viewInit = $(_.template(this.templateList.init)(this.model.attributes));
			this.$viewInit.appendTo(this.$el);
			this.resize();
		}
	},
		
	parseLocalEvms: function(localData) {
        let evms = {};
		_.each(localData, function(i) {
			if (i.answered && i.loopMapping == "" && (!i.isLoopIndex || (i.isLoopIndex && i.value !== "0")) && !i.defaultnotasked)
			{
				evms[i.name] = _.clone(i);
				if (i.options != undefined && i.options != "") evms[i.name].value = UserDocs.View.Modal.EVMModal.getOptionLabel(i, evms[i.name].value);
				if (i.typeName == "date") { evms[i.name].value = ele.date.formatDate(ele.date.flipReverseDate(evms[i.name].value)); }
				
				if (i.isLoopIndex){
					evms[i.name].children = {};
					_.each(localData, function(j){
						if (j.loopMapping == i.name)
						{
							evms[i.name].children[j.name] = j;
						}
					});
				}
			}
		});
		return evms;
	},

	parseEvms: function(localData, externalData, commonData) {
        let evms = {};
        let localEVMs = {};

		if (commonData != "") {
			
			//format data into a searchable object
			_.each(localData, function(i) {
				localEVMs[i.name] = _.clone(i);
			});
			
			_.each(externalData, function(i){
				if (($.inArray(i.name, commonData) > -1 || i.isLoopIndex === 1) && i.answered && i.loopMapping == "" && !i.defaultnotasked && i.risk == 0)
				{
					console.log('populated');
					evms[i.name] = {
						insertAnswered: i.answered,
						insertValue: i.value,
						label: i.label,
						isLoopIndex: i.isLoopIndex
					};
					if (i.options != undefined && i.options != "") {
						evms[i.name].insertValue = UserDocs.View.Modal.EVMModal.getOptionLabel(i, evms[i.name].insertValue);
					}
					if (i.typeName == "date") { evms[i.name].insertValue = ele.date.formatDate(ele.date.flipReverseDate(evms[i.name].insertValue)); }
					if(i.isLoopIndex == 0) {
						i.isLoopIndex = false;
					} else {
						i.isLoopIndex = true;
					}
					if (i.isLoopIndex || i.isLoopIndex == 1){
						if ((i.isLoopIndex) && i.value === "0") {							
							delete evms[i.name];
						} else {
                            let loopToFlat = false;
							evms[i.name].children = {};
							_.each(externalData, function(j){
								if (j.loopMapping == i.name && commonData.indexOf(j.name.replace(/\[.*?\]/g, "")) > -1)
								{
									//add source evm to list
									evms[i.name].children[j.name] = {
										insertAnswered: j.answered,
										insertValue: j.value,
										label: j.label
									};
									
									//see if we can find a local evm we're overwriting
									if (localEVMs[j.name]) { 
										//find loop => existing loop
										$.extend(evms[i.name].children[j.name], localEVMs[j.name]);
									} else if (localEVMs[j.name.replace(/\[.*?\]/g, "")] && localEVMs[j.name.replace(/\[.*?\]/g, "")].loopControlled == 1){
										//find loop = > empty loop
										$.extend(evms[i.name].children[j.name], localEVMs[j.name.replace(/\[.*?\]/g, "")]);
									} else if (localEVMs[j.name.replace("[1]", "")]){
										//find loop => flat
										$.extend(evms[i.name].children[j.name], localEVMs[j.name.replace("[1]", "")]);
										loopToFlat = true; //we only show one layer of the loop when passing from loop => flat so flag it now
									}
								}
							});
							//no loop EVMs were found in the commonData match - remove loop index from matches.
							if (_.size(evms[i.name].children) == 0) delete evms[i.name];
							//remove secondary+ loop items
							if (loopToFlat) {
								evms[i.name].insertValue = Math.min(1, evms[i.name].insertValue); //set loop index to max 1
								_.each(evms[i.name].children, function(j, key) {
									if (key.indexOf("[1]") == -1) delete evms[i.name].children[key];									
								});
							}
						}
					} 

					//add local data
					if (localEVMs[i.name] && (!i.isLoopIndex || i.isLoopIndex == 0)) {						
                        let j = localEVMs[i.name];
						if (j.readOnly == 1) {
							delete evms[i.name];
						} else {
							if (j.options != undefined && j.options != "") {
								j.value = UserDocs.View.Modal.EVMModal.getOptionLabel(j, j.value);
							}
							if (j.typeName == "date") { j.value = ele.date.formatDate(ele.date.flipReverseDate(j.value)); }
							$.extend(evms[i.name], j);
						}
					} else if (localEVMs[i.name + "[1]"]) {
                        let j = localEVMs[i.name + "[1]"];
						if (j.readOnly == 1) {
							delete evms[i.name];
						} else {
							if (j.options != undefined && j.options != "") {
								j.value = UserDocs.View.Modal.EVMModal.getOptionLabel(j, j.value);
							}
							if (j.typeName == "date") { j.value = ele.date.formatDate(ele.date.flipReverseDate(j.value)); }
							
							$.extend(evms[i.name], j);
						}
					}
				}				
			});

		}
		return evms;
	},
	
	parseRegEvms: function(localData, regData) {
        let evms = {};
		if (regData) {
			_.each(localData, function(j) {
				_.each(regData, function(v, i) {
					if (j.name == i)
					{
						evms[i] = _.clone(j);
						evms[i].insertValue = v;
						if (j.options != undefined && j.options != "") {
							evms[i].insertValue = UserDocs.View.Modal.EVMModal.getOptionLabel(j, evms[i].insertValue);
						}
						if (evms[i].typeName == "date") { evms[i].insertValue = ele.date.formatDate(ele.date.flipReverseDate(evms[i].insertValue)); }
					}
				});
			});
		}
		return evms;
	},
	
	/** show the list of EVMs to select from */
	showDataImport: function(externalData, commonData, textEdited) {

		this.helpTemplate = this.helpTemplateList.transfer;
		this.$viewLoading.hide();
		if (this.$viewDataPicker) this.$viewDataPicker.remove();
		this.$viewDataPicker = $(
			_.template(this.templateList.transfer)( 
				{
					'evmData': this.parseEvms(this.evmdocument.EVMData, externalData, commonData),
					'allowBack': this.allowBack,
					'DOCUMENTTEXTWASEDITED': textEdited
				}
			)
		);		
		
		this.$viewDataPicker.appendTo(this.$el);

		this.resize();
	},
	
	/** submit the list of EVMs */
	submitEVMDocumentTable: function(e) {
        let _this = this;
        let form = this.getActiveForm();
        let evmList = [];
        let fields = form.find('input.e_evm_transfer_field:checked');
		$.each(fields, function(i, v){
			evmList.push($(v).attr('name'))
		});
		if (evmList.length == 0) {
			alert(i18n('js_evm_select_fields_error'));
		} else {
			this.loading();
			this.removeContinueButton();
			this.evmdocument.copyAllEVMs(this.currentDoc, evmList.join(",")).then(function(data){
				_this.$viewLoading.hide();
				_this.helpTemplate = _this.helpTemplateList.transfer_summary;
				_this.modal.dialog("option", "title", i18n('js_evm_import_successful'));
				if (_this.$viewSummary) _this.$viewSummary.remove();
				_this.$viewSummary = $(_.template(_this.templateList.summary)({'evms': _this.parseLocalEvms(_this.evmdocument.EVMData), evmList: evmList, 'failures': data.FAILURES, 'addMore': _this.allowMultiple}));
				_this.$viewSummary.appendTo(_this.$el);
				_this.resize();
			}).catch((e) => {
			    console.log("ERROR", e);
				_this.$viewLoading.hide();
				_this.addContinueButton();
				$("<p>" + i18n('js_unexpected_error') + "</p>").appendTo(_this.$el);
			});
		}
	},
		
	/** display a list of documents */
	showDocumentList: function(e) {
        let _this = this;
		this.currentDoc = null;
		if (this.$viewDocs) this.$viewDocs.remove();
		this.loading();
		this.evmdocument.getDocumentList().then(function(docData){
			_this.sourceDocList = docData;
			_this.addContinueButton();
			_this.helpTemplate = _this.helpTemplateList.documents;
            _this.$el.before('<div id="modal-title-custom" class="modal-title-custom"><h2>' + i18n('js_evm_please_select_document') + '</h2></div>');
			_this.$viewLoading.hide();
			_this.$viewDocs = $(_.template(_this.templateList.documents)({
				'documents': _this.sourceDocList, 
				'EVMCount': _this.evmdocument.EVMData.length, 
				'completedEVMCount': _.size(_this.parseLocalEvms(_this.evmdocument.EVMData)),
				'documentId': _this.model.id,
				'reverseRelevance': false
			}));
			_this.$viewDocs.appendTo(_this.$el);
			_this.$viewDocs.find('.e_evm_orderby .e_evm_orderby_selected').click();
			
			//if there are no results, show 'none found'
			if (_this.$viewDocs.find('.e_evm_document_search').children().length == 0) {
				_this.$viewDocs.find('.e_evm_document_search').hide();
				_this.$viewDocs.find('.e_evm_document_search_none').show();
			}
			_this.resize();
		})
	},
	
	/** select a document to display EVM data */
	showDocumentData: function(e) {
        let _this = this;
		this.currentDoc = $(e.target).data('documentid');
        $('.modal-title-custom h2').text('');
		this.loading();
		this.evmdocument.getExternalEVMs(this.currentDoc).then((evmData) => {
			_this.evmdocument.getCommonEVMs(_this.currentDoc).then(function(commonEvms){
				$('.modal-title-custom h2').text(i18n('js_evm_matching_fields'));
				_this.addContinueButton();
				_this.showDataImport(evmData.EVMS, commonEvms, _this.sourceDocList.find(function(x){return x.DOCUMENTID===_this.currentDoc;}).DOCUMENTTEXTWASEDITED);
                _this.resize();
			});
		}).catch(
		function (){
			_this.$viewLoading.hide();
			_this.addContinueButton();
			$("<p>" + i18n('js_unexpected_error') + "</p>").appendTo(_this.$el);
		});
	},
	
	/** show registration data */
	showRegistrationData: function(e) {
        let _this = this;
		this.loading();
		this.evmdocument.getRegistrationEVMs().then(function(regData) {
			_this.helpTemplate = _this.helpTemplateList.register;
			_this.modal.dialog("option", "title", i18n('js_evm_import_reg_to_doc'));
			_this.clear();
			_this.addContinueButton();
			if (_this.$viewReg) _this.$viewReg.remove();
			_this.$viewReg = $(_.template(_this.templateList.register)({evms: _this.parseRegEvms(_this.evmdocument.EVMData, regData)}));
			_this.$viewReg.appendTo(_this.$el);
			_this.resize();
		});
	},
	
	/** submit registration data */
	submitRegistrationEVMs: function(e) {
        let _this = this,
			evmList = [],
			form = this.getActiveForm(),
			fields = form.find('input.e_evm_transfer_field:checked');
		this.allowMultiple = false;
		$.each(fields, function(i, v){
			evmList.push($(v).attr('name'))
		});
		if (evmList.length == 0) {
			alert(i18n('js_evm_select_fields_error'));
		} else {
			this.loading();
			this.removeContinueButton();
			this.evmdocument.copyRegistrationEVMs(evmList.join(",")).then(function(data){
				_this.$viewLoading.hide();
				_this.helpTemplate = _this.helpTemplateList.register_summary;
				_this.modal.dialog("option", "title", i18n('js_evm_import_successful'));
				if (this.$viewSummary) this.$viewSummary.remove();
				_this.$viewSummary = $(_.template(_this.templateList.summary)({'evms': _this.parseLocalEvms(_this.evmdocument.EVMData), evmList: evmList, 'failures': data.FAILURES, 'addMore': _this.allowMultiple}));
				_this.$viewSummary.appendTo(_this.$el);
				_this.resize();
			});
		}
	},
	
	/**
	 * Open the created document
	 */
	openTemplate: function(e) {
		let vars = {documentid: this.evmdocument.id};
		if (ele.uri.getParameterByName(this.destinationUrl, 'productpriceid')) {
			vars.productpriceid = ele.uri.getParameterByName(this.destinationUrl, 'productpriceid');
		}
		
		this.close();
		
		window.top.location.href = ele.uri.buildUrl("assembler", vars);
		
		return false;
	},
	
	setDataField: function(e){
        let input = $(e.target);
		input.prop("checked", !input.prop("checked"));
		this.setDeselected(input);
	},
	
	setDeselected: function(checkbox){
        let parentRow = checkbox.parent('td').parent('tr');
		if (checkbox.prop("checked")) {
			parentRow.removeClass('deselected');
			if (parentRow.attr("id") != null) {
				parentRow.siblings("[data-parent="+parentRow.attr("id")+"]").removeClass('deselected');
			}
		} else {
			parentRow.addClass('deselected');
			if (parentRow.attr("id") != null) {
				parentRow.siblings("[data-parent="+parentRow.attr("id")+"]").addClass('deselected');
			}
		}
		this.updateEVMCounts(checkbox);
	},

    getActiveForm: function() {
	    return $('#document-evm-modal > div:visible .e_evm_transfer_form, #document-evm-modal > .e_evm_transfer_form:visible');
    },
	
	toggleDataField:function(e){
        let input = $(e.target).parent().find("input");
		if (input.length > 0) {
			input.prop("checked", !input.prop("checked"));
			this.setDeselected(input);
		}
	},

	toggleAllDataFields: function(e){
        let _this = this;
        let fields = this.getActiveForm().find('.e_evm_transfer_data input[type=checkbox]');
		if ($(e.target).is(":checked")) {
			fields.prop('checked', 'checked');
		} else {
			fields.prop('checked', '');
		}
		fields.each(function(){
			_this.setDeselected($(this));
		});
		this.updateEVMCounts(fields);
	},
	
	updateEVMCounts: function(checkbox){
		//update counts
        let form = this.getActiveForm();
        let fields = form.find('.e_evm_transfer_data_table input[type=checkbox]').length;
        let selectedFields = form.find('.e_evm_transfer_data_table input[type=checkbox]:checked').length;

		form.find('#e_evm_fields_selected #e_evm_fields_selected_min').text(selectedFields);

		//if all checkboxes are deselected toggle check all
		if (selectedFields == fields) {
			form.find("[name=e_evm_transfer_toggle_all]").prop("checked", true);
		} else if (selectedFields == 0) {
			form.find("[name=e_evm_transfer_toggle_all]").prop("checked", false);
		}
	},

	/* take value of search box and filter divs inside sibling search container */
	search: function(e) {
        let _this = this;
		if (e.which==9 || e.which==17 || e.which == 91) {
      		return; // Ignore this event if its ctrl key or tab key 
    	}  
    	clearTimeout(this.searchTimer);    	
		this.searchTimer = setTimeout(function() {
			_this.searchSiblings(e);
		}, 300);
	},
	
	searchSiblings: function(e) {
        let searchString = $(e.target).val().toString().toLowerCase();
        let searchItems = $(e.target).closest('.e_evm_choose_template, .e_evm_choose_document').find('.e_evm_document_search').children();
        let noneFound = $(e.target).closest('.e_evm_choose_template, .e_evm_choose_document').find('.e_evm_document_search_none');
		
		noneFound.hide();
		searchItems.parent().show();
        let found = false;

		$.each(searchItems, function(i, v){
            let searchElements = $(this).find('.e_evm_searchable');
            let reg = new RegExp('(' + searchString + ')', 'i');
			if (searchElements.text().toLowerCase().indexOf(searchString) > -1) {
				found = true;
				$.each(searchElements, function() {
					$(this).html($(this).text().replace(reg, '<span style="background-color:#cae3fc;">$1</span>'));
				})
				$(this).show();
			} else {
				$(this).hide();
			}
		});
		if (!found) {
			noneFound.show();
			searchItems.parent().hide();
		}
	},
	
	sort: function(e){
		$(e.target).addClass('e_evm_orderby_selected').siblings().removeClass('e_evm_orderby_selected');
		$(e.target).parent().siblings().find('a').removeClass('e_evm_orderby_selected');
        let sortKey = $(e.target).data('sort');
        let searchItems = $(e.target).closest('.e_evm_document_select_search').siblings('.e_evm_document_search').children();

		searchItems.toArray().sort(this.sortFunctions[sortKey]);
		searchItems.parent().append(searchItems);
	},
	
	sortFunctions: {
		'az' : function (a, b) {
		    a = $(a).data("title");
		    b = $(b).data("title");
		    if(a > b) {
		        return 1;
		    } else if(a < b) {
		        return -1;
		    } else {
		        return 0;
		    }
		},
		'za': function (a, b) {
		    a = $(a).data("title");
		    b = $(b).data("title");
		    if(a > b) {
		        return -1;
		    } else if(a < b) {
		        return 1;
		    } else {
		        return 0;
		    }
		},
		'updated': function (a, b) {
		    a = $(a).data("updated");
		    b = $(b).data("updated");
		    if(a > b) {
		        return -1;
		    } else if(a < b) {
		        return 1;
		    } else {
		        return 0;
		    }
		},
		'relevance': function (a, b) {
		    a = $(a).data("relevance");
		    b = $(b).data("relevance");
		    if(a > b) {
		        return -1;
		    } else if(a < b) {
		        return 1;
		    } else {
		        return 0;
		    }
		}
	},

	addContinueButton: function() {
		if (this.modal.closest(".ui-dialog").find(".ui-button-continue").length == 0) {
            let _this = this;
            let elem = $('<button class="ui-button ui-widget ui-button-continue" role="button" aria-disabled="false"><span class="ui-button-text">'+i18n('js_evm_continue_to_doc') + '</span></button>');
			elem.click(function(){
				_this.openTemplate();
			});
			this.modal.closest(".ui-dialog").find(".ui-dialog-titlebar-close").before(elem);
		}
	},

	removeContinueButton: function() {
		this.modal.closest(".ui-dialog").find(".ui-button-continue").remove();
	},
	
	removeCloseButton: function() {
		this.modal.closest(".ui-dialog").find(".ui-dialog-titlebar-close").hide();
	}
});

/* static functions :o */
UserDocs.View.Modal.EVMModal.getOptionLabel = function(data, value) {
	if (value != undefined && value != "") {
        let options = data.options.split("|");
        let optionlabels = data.optionlabels.split("|");
		for (let i = 0; i < options.length; i++) {
			if (value == options[i]) {
				if (optionlabels[i] != undefined && optionlabels[i] != "") {
					return optionlabels[i];
				}
			}
		}
		return data.value;
	}
	return null;
};